import React, { useContext, useEffect, useState } from "react";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import PropTypes from "prop-types";
import { ConditionContext } from "hooks/ConditionContext";

const ParticipantCameraOffBox = ({
  isAudioOn,
  colorCode,
  latter,
  userNameValue = "",
  isLgIcon = false,
}) => {
  const { openedComponentDrawer } = useContext(ConditionContext);
  const [avatarSize, setAvatarSize] = useState(48);

  useEffect(() => {
    setAvatarSize(isLgIcon ? 80 : openedComponentDrawer.length > 0 ? 36 : 48);
  }, [openedComponentDrawer, isLgIcon]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        background: "#0c1428",
        borderRadius: "12px",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        fontFamily: "'Inter', system-ui, sans-serif",
      }}
    >
      {/* Mic badge — top right */}
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          width: "28px",
          height: "28px",
          borderRadius: "8px",
          background: "rgba(8, 13, 28, 0.75)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          border: "1px solid rgba(255,255,255,0.08)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "12px",
          zIndex: 2,
        }}
      >
        {isAudioOn
          ? <FaMicrophone style={{ color: "#8b9dc3" }} />
          : <FaMicrophoneSlash style={{ color: "#f87171" }} />
        }
      </div>

      {/* Avatar circle */}
      <div
        style={{
          width: `${avatarSize}px`,
          height: `${avatarSize}px`,
          borderRadius: "50%",
          background: colorCode,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontWeight: "700",
          fontSize: `${Math.round(avatarSize * 0.38)}px`,
          letterSpacing: "0.04em",
          flexShrink: 0,
          userSelect: "none",
        }}
      >
        {latter}
      </div>

      {/* Name bar — gradient at bottom */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          padding: "20px 10px 8px",
          background: "linear-gradient(to top, rgba(5,9,22,0.90) 0%, transparent 100%)",
          zIndex: 2,
        }}
      >
        <span
          style={{
            fontSize: "12px",
            fontWeight: "600",
            color: "#e8eeff",
            textShadow: "0 1px 6px rgba(0,0,0,0.8)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "block",
          }}
        >
          {userNameValue}
        </span>
      </div>
    </div>
  );
};

ParticipantCameraOffBox.propTypes = {
  colorCode: PropTypes.string.isRequired,
  userNameValue: PropTypes.string,
  latter: PropTypes.string,
  isAudioOn: PropTypes.bool.isRequired,
  isLgIcon: PropTypes.bool,
};

export default ParticipantCameraOffBox;